import { useMemo } from 'react';
import { useCreatePath } from 'react-admin';

export const useCreateNavigationTargetPath = (
  targetNavigationResource: string | undefined,
  targetNavigationFilters: Record<string, any> = {},
) => {
  const createPath = useCreatePath();

  return useMemo(() => {
    if (!targetNavigationResource) {
      return undefined;
    }

    const path = createPath({
      resource: targetNavigationResource,
      type: 'list',
    });

    const stringifiedFilters = JSON.stringify(
      targetNavigationFilters,
    );

    return `/#${path}?filter=${encodeURIComponent(stringifiedFilters)}`;
  }, [targetNavigationResource, createPath, targetNavigationFilters]);
};
